import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const shipmentProductOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "商品名称",
            prop: "productName",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '品牌',
            prop: 'brandName',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '单位',
            prop: 'unit',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '产品单价',
            prop: 'price',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '出货数量',
            prop: 'number',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '出货总金额',
            prop: 'totalMoney',
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};